import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import { LessonDisplayMode } from '../models/LessonComponent';
import React from 'react';
import Typography from '@mui/material/Typography';
import styles from '../styles/LessonMarkingPanel.module.css';

interface LessonStatusLabelProps {
  displayMode: LessonDisplayMode;
  state: ApiPortfolioState;
  completed: boolean;
  showBorder?: boolean;
}

export function LessonStatusLabel(props: LessonStatusLabelProps) {
  function getStyle(state: ApiPortfolioState, completed: boolean): string {
    let statusStyle;
    switch (state) {
      case ApiPortfolioState.AssessmentSubmit:
      case ApiPortfolioState.AssessmentMark:
        statusStyle = styles.statusSubmitted;
        break;
      case ApiPortfolioState.AssessmentRetry:
        statusStyle = styles.statusRetry;
        break;
      case ApiPortfolioState.AssessmentLock:
      case ApiPortfolioState.QuizLock:
        statusStyle = completed ? styles.statusPassed : styles.statusFailed;
        break;
      case ApiPortfolioState.LessonStart:
        statusStyle = completed
          ? styles.statusCompleted
          : styles.statusIncomplete;
        break;
    }

    return props.showBorder
      ? `${statusStyle} ${styles.lessonStatus}`
      : statusStyle;
  }

  function getLabel(state: ApiPortfolioState, completed: boolean) {
    switch (state) {
      case ApiPortfolioState.AssessmentSubmit:
        return 'Submitted';
      case ApiPortfolioState.AssessmentMark:
        return props.displayMode === 'learn' ? 'Submitted' : 'Marking Started';
      case ApiPortfolioState.AssessmentRetry:
        return props.displayMode === 'learn'
          ? 'Work Required'
          : 'Work Requested';
      case ApiPortfolioState.AssessmentLock:
      case ApiPortfolioState.QuizLock:
        return completed ? 'Passed' : 'Failed';
      case ApiPortfolioState.LessonStart:
        return completed ? 'Completed' : 'Incomplete';
      default:
        return '';
    }
  }

  const { state, completed: complete } = props;
  const style = getStyle(state, complete);
  const label = getLabel(state, complete);
  if (!label) {
    return null;
  }

  return (
    <div className={style}>
      <Typography variant="caption" className={styles.capitalize}>
        {label}
      </Typography>
    </div>
  );
}
